import React from 'react';
import {LabelCountry} from '../Labels';

export class PublicCountry extends React.Component {
  render() {
    const {countryName} = this.props;

    return <LabelCountry>{countryName}</LabelCountry>;
  }
}

export default PublicCountry;
